import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

const ProfitView = () => {
  const chartOptions: ApexOptions = {
    chart: {
      id: "line-chart",
      toolbar: {
        show: true,
      },
    },
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    },
    dataLabels: {
      enabled: false,
      formatter: (val: number) => val.toFixed(2),
      style: {
        fontSize: "12px",
        colors: ["#000"],
      },
    },
    stroke: {
      curve: "smooth",
    },
    markers: {
      size: 5,
    },
    tooltip: {
      enabled: true,
    },
  };

  const chartSeries = [
    {
      name: "Profit",
      data: [30, 20, 40, 60, 10, 70],
    },
  ];

  return (
    <div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={350}
      />
    </div>
  );
};

export default ProfitView;
